module.exports = __webpack_public_path__ + "static/img/hala17.a01926c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hala/hala17.jpg
// module id = zeDw
// module chunks = 1